import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Login from './components/pages/Auth/Login';
import Dashboard from './components/Dashboard/Dashboard';
import MainLayout from './components/Layout/MainLayout';
import Users from './components/pages/Users/Users';
import Orders from './components/pages/Orders/Orders';
import OrderDetail from './components/pages/Orders/OrderDetails';
import GiftManagement from './components/pages/GiftManagement/GiftManagement';
import BillingDetails from './components/pages/Users/BillingDetails';
import NotFound from './components/pageNotFound/404notfound';
import ReferralDiscount from './components/pages/ReferralDiscount/ReferralDiscount';
import ReferralDiscountDetails from './components/pages/ReferralDiscount/ReferralDiscountDetails';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-datepicker/dist/react-datepicker.css';
import './App.css'
import PosthumousGifts from './components/pages/PosthumousGifts/PosthumousGifts';
import MilestoneGifts from './components/pages/MilestoneGifts/MilestoneGifts';
import PosthumousDetails from './components/pages/PosthumousGifts/PosthumousDetails';
import MilestoneDetails from './components/pages/MilestoneGifts/MilestoneDetails';
import Support from './components/pages/Support/Support';
import SupportTicketDetails from './components/pages/Support/SupportTicketDetails';
import Transactions from './components/pages/Transactions/Transactions';
import TransactionDetails from './components/pages/Transactions/TransactionDetails';
import SubscriptionPlans from './components/pages/SubscriptionPlans/SubscriptionPlans';
import SubscriptionDetails from './components/pages/SubscriptionPlans/SubscriptionDetails';
import Profile from './components/pages/Profile/Profile';
// Initialize axios interceptors, toast manager, and global error handler
import './utils/axiosInterceptor';
import './utils/toastManager';
import './utils/globalErrorHandler';
 
 
// Import AuthHelper for better token validation
import { AuthHelper } from './utils/authHelper';
import { SessionProvider } from './contexts/SessionContext';
import { useSessionManager } from './hooks/useSessionManager';

const ProtectedRoute = () => {
  return AuthHelper.hasValidToken() ? <Outlet /> : <Navigate to="/" replace />;
};
 
const PublicRoute = () => {
  return AuthHelper.hasValidToken() ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

const AppContent = () => {
  // Initialize session management at app level
  useSessionManager();
  
  return (
    <Routes>

      {/* Public Routes */}
      <Route element={<PublicRoute />}>
        <Route path="/" element={<Login />} />
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/order-details/:orderId" element={<OrderDetail />} />
          <Route path="/posthumousgifts" element={<PosthumousGifts />} />
          <Route path="/posthumous-details/:orderId" element={<PosthumousDetails />} />
          <Route path="/milestonegifts" element={<MilestoneGifts />} />
           <Route path="/milestone-details/:id" element={<MilestoneDetails />} />
          <Route path="/gift-management" element={<GiftManagement />} />
          <Route path="/billing-details" element={<BillingDetails />} />
          <Route path="/referral-discount" element={<ReferralDiscount />} />
          <Route path="/discount-codes-details/:id" element={<ReferralDiscountDetails />} />
          <Route path="/support" element={<Support />} />
          <Route path="/support/ticket/:ticketId" element={<SupportTicketDetails />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/transactions/:transactionId/:type" element={<TransactionDetails />} />
          <Route path="/subscription-plans" element={<SubscriptionPlans />} />
          <Route path="/subscriptions/:subscriptionId" element={<SubscriptionDetails />} />
          <Route path="/billing-details/:id" element={<BillingDetails />} />
          <Route path="/profile" element={<Profile />} />
        </Route>
      </Route>

      {/* 404 Route */}
        <Route path="*" element={<Dashboard />} />
       
    </Routes>
  );
};
 
function App() {
  return (
    <Router>
      <SessionProvider>
        <AppContent />
        <ToastContainer position="top-right" autoClose={3000} theme="light" />
      </SessionProvider>
    </Router>
  );
}
 
export default App;